var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeightScale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.47682 13.0085C2.52619 12.993 1.8073 12.1419 1.9031 11.1762L3.20641 5.63392C3.39352 4.83821 4.0787 4.25908 4.89585 4.23884C6.18768 4.20684 7.81306 4.20684 9.10488 4.23884C9.92202 4.25908 10.6072 4.83821 10.7943 5.63392L12.0977 11.1762C12.1935 12.1419 11.4746 12.993 10.5239 13.0085C9.4883 13.0255 8.24433 13.0339 7.00037 13.0339C5.7564 13.0339 4.51243 13.0255 3.47682 13.0085Z",
    stroke: "#000000",
    strokeWidth: 1.00333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99958 4.21401C8.03932 4.21401 8.62417 3.62916 8.62417 2.58943C8.62417 1.54969 8.03932 0.964844 6.99958 0.964844C5.95985 0.964844 5.375 1.54969 5.375 2.58943C5.375 3.62916 5.95985 4.21401 6.99958 4.21401Z",
    stroke: "#000000",
    strokeWidth: 1.00333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeightScale);
export default __webpack_public_path__ + "static/media/weight_scale.c6059ac3151ecd0f3ea26c12fba17131.svg";
export { ForwardRef as ReactComponent };